import { API_ENDPOINT } from '@/data'
import { getAuth } from 'firebase/auth'

export const Request = async (props: RequestFunctionProps) => {
    const {
        path,
        method,
        signal,
        body
    } = props

    const auth = getAuth()
    const token = await auth.currentUser?.getIdToken() || ''

    const options: RequestInit = {
        method,
        signal,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': token
        }
    }

    if (body) options['body'] = JSON.stringify({ ...body })

    let response = {
        success: false,
        message: 'Something went wrong while processing your request.',
        data: null
    }

    try {
        const request = await fetch(`${API_ENDPOINT}/${path}`, options)
        response = await request.json()
    }

    catch (error) {
        console.error(error)
    }

    return response
}
